// Extrae el ID de episodio de una URL de Spotify (open.spotify.com/episode/ID
// o spotify:episode:ID) para poder generar el iframe de embed oficial.
export function extractSpotifyEpisodeId(url) {
  if (!url) return null;
  const match = String(url).match(/episode[/:]([a-zA-Z0-9]+)/);
  return match ? match[1] : null;
}
